import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=0efbd596"
import script from "./Food.vue?vue&type=script&lang=ts"
export * from "./Food.vue?vue&type=script&lang=ts"
import style0 from "./Food.vue?vue&type=style&index=0&id=0efbd596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports